<template>
  <settings-modal class="card-activate-modal">
    <template slot="heading">{{ heading }}</template>

    <p>To activate card enter the last 6 digits of the card number</p>

    <v-text-field
      v-model="form.activationCode"
      class="t-activation-code-field"
      label="Activation code"
      placeholder="Last 6 digits"
      counter="6"
      maxlength="6"
      :error-messages="getValidationErrorMessage('activationCode')"
    />

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        class="t-activate-card"
        color="primary"
        medium
        flat
        :disabled="!isFormFilled || loading"
        @click="onSaveButtonClick"
      >activate card</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        medium
        flat
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_CARD_UPDATE } from '@/events/cards'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import IssuingApi from '@/services/Api/IssuingApi'

  // Mixins
  import form from '@/mixins/form'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'CardActivateModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    mixins: [form],
    data () {
      return {
        fieldErrorCustomMessages: {
          activationCode: {
            VALIDATION_ERROR_PATTERN: 'Must be 6 digits long'
          }
        },
        form: { activationCode: null },
        requiredFields: ['activationCode'],
        cardActivateApiRequest: new ApiRequest(IssuingApi.activateCard)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      cardId () {
        return this.modal.data.cardId
      },
      heading () {
        return this.modal.data.heading
      },
      loading () {
        return this.cardActivateApiRequest.loading
      },
      error () {
        return this.cardActivateApiRequest.error
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onSaveButtonClick () {
        this.cardActivateApiRequest
          .execute(this.cardId, this.form.activationCode)
          .then(this.cardActivateSuccessHandler)
          .catch(() => {})
      },
      onCancelButtonClick () {
        this.closeModal()
      },
      cardActivateSuccessHandler () {
        this.$eventHub.$emit(EVENT_CARD_UPDATE)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'Card has been successfully activated.' }
          })
        }, 100)
      }
    }
  }
</script>
